export const GAP = 10;

export const TABLE_FONT_SIZE = 8;
